import React, { useEffect, useState } from "react";
import styles from "./SelectDecor.module.scss";

import { fakeApi } from "../../assets/fakeApi";
import { Outlet, useLocation, useNavigate } from "react-router-dom";

function SelectDecor() {
  const [name, setName] = useState("vitalnya");
  const [type, setType] = useState("interior");
  const navigate = useNavigate();
  const api = fakeApi.find((i) => i.type === type).data;
  const location = useLocation();

  const interior = type === "interior";

  useEffect(() => {
    if (location.pathname === "/select/in") {
      setType("interior");
      setName("vitalnya");
    } else if (location.pathname === "/select/ex") {
      setType("exterior");
      setName("cottage");
    } else {
      navigate(`/render/exterior/cottage/1`, {
        state: { name: "cottage", type: "exterior", mosaic: true },
      });
    }
  }, [location.pathname, navigate]);

  return (
    <>
      <div className={styles.wrapper}>
        {interior ? (
          <h1>Оберіть тип кімнати та інтер'єру</h1>
        ) : (
          <h1>Оберіть тип будинку</h1>
        )}
        <div className={styles.bottomCase}>
          <ul className={styles.namesContainer}>
            {api?.map(({ id, tag, link }) => (
              <li
                key={id}
                onClick={() => setName(link)}
                className={name === link ? styles.active : undefined}
              >
                {tag}
              </li>
            ))}
          </ul>

          <ul className={styles.imagesContainer}>
            {api
              ?.find((i) => i.link === name)
              .rooms?.map(({ background, id }) => (
                <li
                  key={id}
                  onClick={() => {
                    navigate(`/render/${type}/${name}/${id}`, {
                      state: { name, type },
                    });
                  }}
                >
                  <img src={background} alt="Оберіть кімнату" />
                </li>
              ))}
          </ul>
        </div>
      </div>
      <Outlet />
    </>
  );
}

export default SelectDecor;
